import { formatDateToSydneyTimeZone } from '../../utils/dateUtils';

const entryTypeConfig = {
  auto: { label: 'Auto', className: 'border-green-600 text-green-600' },
  manual: { label: 'Manual', className: 'border-blue-600 text-blue-600' },
  qr: { label: 'QR', className: 'border-purple-600 text-purple-600' },
};

const formatDuration = (startTime, endTime) => {
  const diffMs = new Date(endTime) - new Date(startTime);
  const totalMinutes = Math.floor(diffMs / 60000);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h${m}m`;
};

const generateTimeEntryColumns = ({
  showLabourerField = true,
  showProjectField = true,
  onEditClicked,
  onRemoveClicked
}) => {
  const columns = [
    {
      name: 'Period',
      selector: row => row.startTime,
      cell: row => {
        const startFull = formatDateToSydneyTimeZone(row.startTime, 'MMM d yyyy HH:mm');
        if (!row.endTime) return `${startFull} – Ongoing`;

        const startDay   = formatDateToSydneyTimeZone(row.startTime, 'yyyy-MM-dd');
        const endDay     = formatDateToSydneyTimeZone(row.endTime,   'yyyy-MM-dd');
        const startMonth = formatDateToSydneyTimeZone(row.startTime, 'yyyy-MM');
        const endMonth   = formatDateToSydneyTimeZone(row.endTime,   'yyyy-MM');
        const startYear  = formatDateToSydneyTimeZone(row.startTime, 'yyyy');
        const endYear    = formatDateToSydneyTimeZone(row.endTime,   'yyyy');
        const startTime  = formatDateToSydneyTimeZone(row.startTime, 'HH:mm');
        const endTime    = formatDateToSydneyTimeZone(row.endTime,   'HH:mm');

        if (startDay === endDay) {
          // Jun 8 2026 08:32 – 17:04
          return `${startFull} – ${endTime}`;
        }
        if (startMonth === endMonth) {
          // Jun 8–9 2026 · 01:00–01:00
          const d1 = formatDateToSydneyTimeZone(row.startTime, 'd');
          const d2 = formatDateToSydneyTimeZone(row.endTime, 'd');
          const mon = formatDateToSydneyTimeZone(row.startTime, 'MMM');
          return `${mon} ${d1}–${d2} ${startYear} · ${startTime}–${endTime}`;
        }
        if (startYear === endYear) {
          // Jun 8 – Jul 3 2026 · 01:00–09:00
          const d1 = formatDateToSydneyTimeZone(row.startTime, 'MMM d');
          const d2 = formatDateToSydneyTimeZone(row.endTime, 'MMM d');
          return `${d1} – ${d2} ${startYear} · ${startTime}–${endTime}`;
        }
        // Dec 31 2025 – Jan 1 2026 · 23:00–06:00
        const d1 = formatDateToSydneyTimeZone(row.startTime, 'MMM d yyyy');
        const d2 = formatDateToSydneyTimeZone(row.endTime, 'MMM d yyyy');
        return `${d1} – ${d2} · ${startTime}–${endTime}`;
      },
      grow: 2
    },
    {
      name: 'Duration',
      cell: row => row.endTime ? formatDuration(row.startTime, row.endTime) : 'Ongoing'
    },
    {
      name: 'Type',
      selector: row => row.type,
      format: row => row.type === 'work' ? 'Work' : 'Sick Leave'
    },
    {
      name: '',
      selector: row => row.entryType,
      cell: row => {
        const { label, className } = entryTypeConfig[row.entryType] || entryTypeConfig.manual;
        return <button className={`${className} py-1 px-2 rounded-md text-xs font-semibold`}>{label}</button>;
      }
    }
  ];

  const actionsColumn = {
    right: "true",
    cell: row => (
      <div className='flex items-center gap-2'>
        {onEditClicked && (
          <button
            onClick={() => onEditClicked(row)}
            className='p-1 px-2 font-bold cursor-pointer rounded-md bg-yellow-600 text-white text-nowrap'
          >
            Edit
          </button>
        )}

        {onRemoveClicked && (
          <button
            onClick={() => onRemoveClicked(row)}
            className='p-1 px-2 font-bold cursor-pointer rounded-md bg-red-600 text-white text-nowrap'
          >
            Remove
          </button>
        )}
      </div>
    )
  }

  if (showLabourerField) columns.unshift({
    name: 'Labourer',
    selector: row => row.labourer.user.fullName
  });

  if (showProjectField) columns.unshift({
    name: 'Project',
    selector: row => row.project.name
  });

  if (onEditClicked || onRemoveClicked) {
    columns.push(actionsColumn);
  }

  return columns;
};

export default generateTimeEntryColumns;
